export default "__VITE_ASSET__BPR0Xpvk__"